import Bill from "../../Models/Bill";
import {Customer} from "../../Models/Customer";

export const GET_BILLING = "Billing/getBills";


export interface BillingReducerType {
  bills: Bill[];
  billOptionList: any[]
}

export interface BillingParams {
  payment_date?: Date;
  customer?: Customer | string;
  all?: boolean;
}
